import PatientRegistrationForm from "./Components/PatientRegistrationForm";

const PatientPortalRegistration = () => {
  return (
    <div>
      <PatientRegistrationForm />
    </div>
  );
};

export default PatientPortalRegistration;
